let maskId: number = 0;
export const generateMaskId = (): string => {
  maskId += 1;
  return `mask_${maskId}`;
};

let patternId: number = 0;
export const generatePatternId = (): string => {
  patternId += 1;
  return `pattern_${patternId}`;
};

let imageId: number = 0;
export const generateImageId = (): string => {
  imageId += 1;
  return `image_${imageId}`;
};

let svgId: number = 0;
export const generateSvgId = (): string => {
  svgId += 1;
  return `svg_${svgId}`;
};
